import Repository from './Repository';
const resource = '/content/feature/event';

export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
